import React from "react";
import MutedText from "../../ui/MutedText";
import { BodySelect, EndEffectorSelect, Row, XYZRow } from "./NodeInspectorFields";

export default function PickPlaceSetupSection({
  behaviorDoc,
  eeOpts,
  getFieldError,
  onApplyDocument,
  opts,
  pickPlaceSetup,
  validateNumeric,
}) {
  return (
    <div className="space-y-3 rounded border border-gray-700 bg-gray-900/50 p-3">
      <div className="text-xs font-semibold uppercase tracking-wide text-gray-300">
        Pick & Place Setup
      </div>
      <Row label="Target object">
        <BodySelect
          opts={opts}
          value={pickPlaceSetup.randomizeNode.bodyUuid}
          onPick={(v) => {
            const currentPickY = Number(pickPlaceSetup.pickNode.y);
            const pickYOffset = Number.isFinite(currentPickY) ? currentPickY : 0.15;
            const nextNodes = {
              ...behaviorDoc.nodes,
              [pickPlaceSetup.randomizeNode.id]: {
                ...pickPlaceSetup.randomizeNode,
                bodyUuid: v,
              },
              [pickPlaceSetup.pickNode.id]: {
                ...pickPlaceSetup.pickNode,
                targetBodyUuid: v,
                x: 0,
                y: pickYOffset,
                z: 0,
              },
            };
            pickPlaceSetup.graspGateNodes.forEach((gate) => {
              nextNodes[gate.id] = { ...gate, bodyUuid: v };
            });
            pickPlaceSetup.pickEeGateNodes.forEach((gate) => {
              nextNodes[gate.id] = { ...gate, targetBodyUuid: v };
            });
            onApplyDocument({
              ...behaviorDoc,
              nodes: nextNodes,
            });
          }}
        />
      </Row>
      <Row label="Dropoff target body (snap)">
        <BodySelect
          opts={opts}
          value={pickPlaceSetup.dropNode.targetBodyUuid || ""}
          placeholder="— manual XYZ (no snap) —"
          onPick={(v) => {
            const currentDropY = Number(pickPlaceSetup.dropNode.y);
            const dropYOffset = Number.isFinite(currentDropY) ? currentDropY : 0.15;
            const nextDropNode = v
              ? {
                  ...pickPlaceSetup.dropNode,
                  targetBodyUuid: v,
                  x: 0,
                  y: dropYOffset,
                  z: 0,
                }
              : {
                  ...pickPlaceSetup.dropNode,
                  targetBodyUuid: "",
                };
            const nextNodes = {
              ...behaviorDoc.nodes,
              [pickPlaceSetup.dropNode.id]: nextDropNode,
            };
            pickPlaceSetup.dropEeGateNodes.forEach((gate) => {
              nextNodes[gate.id] = { ...gate, targetBodyUuid: v || "" };
            });
            onApplyDocument({
              ...behaviorDoc,
              nodes: nextNodes,
            });
          }}
        />
      </Row>
      <Row label="Dropoff XYZ (manual override)">
        <XYZRow
          keys={["x", "y", "z"]}
          node={pickPlaceSetup.dropNode}
          onChange={(nextDropNode) => {
            onApplyDocument({
              ...behaviorDoc,
              nodes: {
                ...behaviorDoc.nodes,
                [pickPlaceSetup.dropNode.id]: { ...nextDropNode, targetBodyUuid: "" },
              },
            });
          }}
          fieldPrefix="pickPlace.dropoff"
          validateNumeric={validateNumeric}
          getFieldError={getFieldError}
        />
      </Row>
      <Row label="End-effector ref (all move steps)">
        <EndEffectorSelect
          opts={eeOpts}
          value={pickPlaceSetup.dropNode.endEffectorRef}
          onPick={(value) => {
            const nextNodes = { ...behaviorDoc.nodes };
            pickPlaceSetup.moveNodes.forEach((n) => {
              nextNodes[n.id] = { ...n, endEffectorRef: value };
            });
            [...pickPlaceSetup.pickEeGateNodes, ...pickPlaceSetup.dropEeGateNodes].forEach(
              (gate) => {
                nextNodes[gate.id] = { ...gate, endEffectorRef: value };
              }
            );
            onApplyDocument({
              ...behaviorDoc,
              nodes: nextNodes,
            });
          }}
        />
      </Row>
      <MutedText className="text-xs leading-snug">
        These controls update the linked steps in this preset so you do not need to edit each node
        separately.
      </MutedText>
    </div>
  );
}
